import React, { useMemo, useState } from "react";
import CRMPipelineTab from "../components/CrmPipeline.jsx";
import CRMContactsTab from "../components/CrmContacts.jsx";
import CRMServicesTab from "../components/CrmServices.jsx";
import CRMActivitiesTab from "../components/CrmActivities.jsx";
import PageHeader from "./PageHeader.jsx";
import "../styles/crm/crm.css";

const CRMPage = () => {
  const [activeTab, setActiveTab] = useState("pipeline");

  const tabs = useMemo(
    () => [
      { key: "pipeline", label: "Pipeline" },
      { key: "contacts", label: "Contactos" },
      { key: "services", label: "Servicios" },
      { key: "activities", label: "Actividades" },
    ],
    []
  );

  return (
    <div className="crm-page-container">
      <div className="crm-header">
        <div>
          <h1><PageHeader title="CRM Clínica" /></h1>
          <p>Gestión de pipeline, contactos, servicios y actividades.</p>
        </div>
      </div>

      <div className="crm-tabs segmented">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`crm-tab segmented-btn ${
              activeTab === tab.key ? "is-active" : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="crm-tab-content">
        {activeTab === "pipeline" && <CRMPipelineTab />}
        {activeTab === "contacts" && <CRMContactsTab />}
        {activeTab === "services" && <CRMServicesTab />}
        {activeTab === "activities" && <CRMActivitiesTab />}
      </div>
    </div>
  );
};

export default CRMPage;